import { Link } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import {
    actionAppearance, bulkDeleteModal, checkAll, showModal, formFail, handleSubmitActions,
    paginateData, sortFunc, formSuccess, iAmHigherAuthority, isBannerPresent, headerFilterFunc, searchFunc
} from "../libs.jsx";
import ApiRequester from "./ApiRequester.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import {CSVLink} from "react-csv";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import {toast, ToastContainer} from "react-toastify";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";

const SystemDevices = (props) => {
    let dData, bData, headerData, csvHeaders;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    headerData = [
        {label: "Name", key: "device_name", align: "center", filtered: true},
        {label: "Model", key: "model_name", align: "center", filtered: true},
        {label: "Serial Number", key: "manufacture_uuid", align: "center", filtered: true},
        {label: "Area", key: "area_name", align: "center", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Network", key: "network_id", align: "center", filtered: true},
        {label: "Last Active", key: "last_active", align: "center", type: "datetime"},
        {label: "Last Known Server", key: "mac_addr", align: "center", filtered: true}
    ];

    csvHeaders = [
        {label: "Name", key: "device_name"},
        {label: "Device Model", key: "model_name"},
        {label: "Serial Number", key: "manufacture_uuid"},
        {label: "Linked To", key: "device_type"},
        {label: "Area Name", key: "area_name"},
        {label: "Device Type", key: "standard_name"},
        {label: "Last Known Server", key: "mac_addr"}
    ];

    if (iAmHigherAuthority(99, dData.role_weight)){
        csvHeaders.splice(0, 0, {label: "Device ID", key: "device_id"});
    }

    // Permission Variables
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(80, dData.role_weight));
    const [read, setRead] = useState(true);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Main Table Variables
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [loadState, setLoadState] = useState("system");
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [deviceIdList, setDeviceIdList] = useState([]);
    const [search, setSearch] = useState("");
    const [headerFilters, setHeaderFilters] = useState([]);
    const [sorter, setSorter] = useState({
        sortColumn: "description",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Other Enact Once Variables
    const [csvLink, setLink] = useState({
        filename: "system_devices.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getrepeaterbycampus", reqType: "stored"}).then(data => {
                    setDataOrigin(data);
                    setOriginLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={deleteRights}
                                writeAccess={deleteRights} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={() => {}} parentComponent={"Community"}
                                dData={dData} checkboxlist={deviceIdList} setCheckboxId={(value) => {setDeviceIdList(value)}}
                                checkidkey={"device_id"} />);
    }, [activeData, sorter, page, perPage, dataOrigin, deviceIdList]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
    }, [dataOrigin]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        )
    }, [csvLink]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(dataOrigin, headerFilters, headerData);

        searchKeys = ["device_name", "manufacture_uuid", "area_name", "model_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin, headerFilters]);

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setDeviceIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({device_id: dContent[i][0]});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "system_device_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setDeviceIdList([]);
                    formSuccess("Devices marked inactive.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn"]);
                }
                else{
                    formFail(`Failed to delete with error: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function repeaterFlashSubmit(){
        handleSubmitActions("flashBtn", "loadFlashBtn");
        ApiRequester({reqEndpoint: "mytransaction", TransType: "repeater_flash",
                            CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                setRead(false);
                formSuccess(`Repeater flash sent, may take several minutes to update, longer with more repeaters.`,
                    "flashBtn", "loadFlashBtn");
                setCount(0);
            } else {
                formFail(`Error encountered, failed to flash`, "flashBtn", "loadFlashBtn");
            }
        });
    }

    function syncSubmit(){
        let msg;
        handleSubmitActions("syncSubmit", "syncLoadSubmit");
        ApiRequester({reqEndpoint: "mqtt", Operation: "reboot-server", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if(data[0]){
                msg = "Sync triggered, please allow up to 3 minutes for changes to take effect.";
                formSuccess(msg, "syncSubmit", "syncLoadSubmit");
            }
            else{
                msg = "Error syncing, contact support for assistance if error persists.";
                formFail(msg, "syncSubmit", "syncLoadSubmit");
            }
        });
    }

    function restoreSubmit(){
        let msg;
        handleSubmitActions("restoreSubmit", "restoreLoadSubmit");
        ApiRequester({reqEndpoint: "mqtt", Operation: "restore-server", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if(data[0]){
                msg = "Restore triggered, please allow up to 3 minutes for changes to take effect.";
                formSuccess(msg, "restoreSubmit", "restoreLoadSubmit");
            }
            else{
                msg = "Error restoring, contact support for assistance if error persists.";
                formFail(msg, "restoreSubmit", "restoreLoadSubmit");
            }
        });
    }

    const tableHeaders = <TableHeaders checkbox={deleteRights} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, deviceIdList, setDeviceIdList)}
                                       writeAccess={deleteRights} sortOrder={sorter.sortOrder} originData={dataOrigin} headerFiltersOn={true}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={deviceIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])}
                                       headerFilters={headerFilters} setHeaderFilters={setHeaderFilters} setPage={setPage} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                <Button class={"btn btn-primary me-4"} iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                         icon={true} iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"} iconName={"cloud_sync"}
                         text={"Sync Local"} id={"syncSubmit"} style={{height: "41.5px", whiteSpace: "nowrap"}} onClick={() => syncSubmit()}
                         title={"Syncs local server with cloud data, will cause the server to go offline momentarily during the process"} />
                <Button class={"btn btn-primary me-4 d-none"} disabled={true} spinner={true} readonly={true} style={{height: "41.5px"}}
                         text={"Syncing..."} id={"syncLoadSubmit"} />
                <Button class={"btn btn-primary me-4"} iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                         icon={true} iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"} iconName={"restore_page"}
                         text={"Restore Data"} id={"restoreSubmit"} style={{height: "41.5px", whiteSpace: "nowrap"}} onClick={() => restoreSubmit()}
                         title={"Restore data performs the sync local reboot, however deletes the database file triggering a re-create."} />
                <Button class={"btn btn-primary me-4 d-none"} disabled={true} spinner={true} readonly={true} style={{height: "41.5px"}}
                         text={"Restoring..."} id={"restoreLoadSubmit"} />
                <Button text={"Flash Repeaters"} class={"btn btn-primary me-4"} iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                        id={"flashBtn"} onclick={() => repeaterFlashSubmit()} icon={true} iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"} iconName={"settings_remote"}
                        title={"Flashes repeaters to get network id from receiver, must be in tamper to flash."} />
                <Button text={"Flashing"} spinner={true} disabled={true} id={"loadFlashBtn"} class={"btn btn-primary me-4 d-none"} />
                {deleteRights && <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, activeData, ["device_name", "manufacture_uuid", "area_name"], ["device_id", ""], "", setDContent)} />}
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"} style={{height: "42px"}}
                            icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={() => {
                                setOriginLoaded(false);
                                setPageLoaded(false);
                            }}/>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Community"} Title={"Devices"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                            <Link to={"/community/devices"}>
                                <Button text={"Nurse Call"}
                                        class={loadState === "inovonics" ? "nav-link active" : "nav-link"}
                                        onClick={() => setLoadState("inovonics")}/>
                            </Link>
                        </li>
                        <li className={"nav-item"}>
                            <Link to={"/community/wander_devices"}>
                                <Button text={"Wandering"}
                                        class={loadState === "accutech" ? "nav-link active" : "nav-link"}
                                        onClick={() => setLoadState("accutech")}/>
                            </Link>
                        </li>
                        {iAmHigherAuthority(99, dData?.role_weight)
                            ? <>
                                <li className={"nav-item"}>
                                    <Link to={"/community/system_devices"}>
                                        <Button text={"System Devices"}
                                                class={loadState === "system" ? "nav-link active" : "nav-link"}
                                                onClick={() => setLoadState("system")}/>
                                    </Link>
                                </li>
                                <li className={"nav-item"}>
                                    <Link to={"/community/server_devices"}>
                                        <Button text={"Servers"}
                                                class={loadState === "server" ? "nav-link active" : "nav-link"}
                                                onClick={() => setLoadState("server")}/>
                                    </Link>
                                </li>
                            </>
                            : <></>
                        }
                    </ul>
                    {!pageLoaded
                        ?   skeleton
                        :   <>
                                <div className={"d-flex justify-content-end mb-2"}>
                                    <span className={"text-muted"} style={{fontSize: "var(--font-size-sm)"}}>
                                        Showing <strong>{Math.min(ppRules.start+1, dataOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, dataOrigin.length)}</strong> of <strong>{dataOrigin.length}</strong> {dataOrigin.length === 1 ? "device" : "devices"}
                                    </span>
                                </div>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {tableRows}
                                    </tbody>
                                </table>
                            </>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            <BulkDeleteModal deletePerform={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkConfirmClose", ppRules.start, ppRules.end)}
                             start={ppRules.start} end={ppRules.end} header={"Disable Devices"} />
            <button
                type={"button"}
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>System Devices Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The System Devices page allows you to view and manage network infrastructure devices such as repeaters and network coordinators. 
                                    This page is available to technical users only and provides tools for system maintenance and synchronization.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Filtering
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Search Bar:</strong> Use the search bar to quickly find devices by name, serial number, model, area, or network ID.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Column Filters:</strong> Click the filter icons in column headers to filter by specific criteria.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-server me-2 text-primary"}></i>Device Information
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Name:</strong> The device name assigned to the system device.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Model:</strong> The device model type.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Serial Number:</strong> The unique serial number for the device.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Area:</strong> The area where the device is located (clickable link to area profile).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Network:</strong> The network ID the device is associated with.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Last Active:</strong> Shows when the device last communicated with the system.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Last Known Server:</strong> The MAC address of the server the device last communicated with.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-cloud me-2 text-primary"}></i>System Maintenance Tools
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Sync Local:</strong> Syncs the local server with cloud data. The server will go offline momentarily during this process. Allow up to 3 minutes for changes to take effect.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Restore Data:</strong> Performs a sync local reboot and deletes the database file, triggering a re-create. Use with caution. Allow up to 3 minutes for changes to take effect.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Flash Repeaters:</strong> Flashes repeaters to get network ID from receiver. Repeaters must be in tamper mode to flash. This process may take several minutes, longer with more repeaters.
                                    </li>
                                </ul>
                                <p className={"mb-2"}>These tools are for advanced system maintenance and should be used carefully.</p>
                            </div>

                            {iAmHigherAuthority(80, dData.role_weight)
                                ?   <div className={"mb-4"}>
                                        <h5 className={"fw-bold mb-2"}>
                                            <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Devices
                                        </h5>
                                        <ul className={"list-unstyled ms-4"}>
                                            <li className={"mb-2"}>
                                                Select one or more devices using the checkboxes.
                                            </li>
                                            <li className={"mb-2"}>
                                                Click <strong>"Delete"</strong> to permanently remove devices from the system.
                                            </li>
                                            <li className={"mb-2"}>
                                                <strong>Warning:</strong> This action cannot be undone. Only delete devices that are no longer in use.
                                            </li>
                                            <li className={"mb-2"}>
                                                Deleting system devices may affect network connectivity and should be done with caution.
                                            </li>
                                        </ul>
                                    </div>
                                : <></>
                            }

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Export"</strong> button to download device data as a CSV file.
                                    </li>
                                    <li className={"mb-2"}>
                                        The export includes device information, network details, and last known server information.
                                    </li>
                                    <li className={"mb-2"}>
                                        Admin users will see additional fields like Device ID in the export.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click column headers to sort the table by that column.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the pagination controls at the bottom to navigate through multiple pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        Adjust the number of items per page using the page size button.
                                    </li>
                                    <li className={"mb-2"}>
                                        System devices are critical infrastructure components - handle with care.
                                    </li>
                                    <li className={"mb-2"}>
                                        Monitor "Last Active" timestamps to ensure devices are communicating properly.
                                    </li>
                                    <li className={"mb-2"}>
                                        Network ID helps identify which network segment a device belongs to.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use maintenance tools during scheduled maintenance windows to minimize disruption.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage} setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)} setPage={(sudocode) => setPage(sudocode)}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default SystemDevices;